import { AgentAllocation } from '../../../../models/AgentsAllocation';
import { Typography } from '@coolblue-development/freddy';

interface SelectedAgentsListProps {
  selectedAgents: AgentAllocation[];
}

export const SelectedAgentsList = ({ selectedAgents }: SelectedAgentsListProps): JSX.Element => {
  return (
    <>
      <Typography variant="h3" mb={'4px'}>
        Selected agents
      </Typography>

      <Typography>You've selected {selectedAgents.length} agents:</Typography>

      <ul>
        {selectedAgents.map(agent => (
          <li key={agent.id}> {agent.username}</li>
        ))}
      </ul>
    </>
  );
};
